const blank = "https://static.vecteezy.com/system/resources/previews/001/921/566/non_2x/businessman-elegant-with-infographic-presentation-free-vector.jpg"

export const officers = [
    {
        name: "Everett Richards",
        position: "President",
        email: "erichards5198@sdsu.edu",
        url: "https://everettrichards.com",
        major: "Computer Science & Applied Math",
        photo: require("../images/officers25/everett.png"),
    },
    {
        name: "Tanish Gheewala",
        position: "Vice President",
        email: "tgheewala4792@sdsu.edu",
        major: "Computer Engineering",
        photo: require("../images/officers25/tanish.png")
    },
    {
        name: "Matthew Long",
        position: "Treasurer",
        email: "",
        major: "Computer Science",
        photo: require("../images/officers25/matt.png"),
    },
    {
        name: "Kurt Rosales",
        position: "Curriculum Chair",
        email: "",
        major: "Computer Science",
        photo: require("../images/officers25/kurt.png"),
    },
    {
        name: "Thea Enache",
        position: "Event Coordinator",
        email: "",
        major: "Public Health",
        photo: require("../images/officers25/thea.png"),
    },
    {
        name: "Shelvy Millado",
        position: "Secretary",
        email: "",
        major: "Computer Science",
        photo: require("../images/officers25/shelvy.png"),
    },
    {
        name: "Patricia Alfonso",
        position: "Media Chair",
        major: "Computer Science",
        photo: require("../images/hack25/committee/patricia.jpg")
    },
    {
        name: "Joann Chen",
        position: "Faculty Advisor",
        email: "jchen27@sdsu.edu",
        url: "https://joannqc.com/",
        major: "Professor of Computer Science",
        photo: require("../images/officers25/chen.png")
    },
]